import React from 'react';
import { Acv as AcvParser } from '@photocarbone/nooco-shared-api-def';
import { StateDTO } from '../../../models/GeneralDTO';
import { useSelector } from 'react-redux';
import { HistogramVignetteComponent } from '@photocarbone/nooco-ui';
import GraphicHeader from '../GraphicHeader/GraphicHeader';

const acvParser = new AcvParser();

function AcvGraphic() {
  const { firstVariant, secondVariant } = useSelector(
    (state: StateDTO) => state.simulator
  );
  const { graphData, graphKeys, impactTotal } = acvParser.processDataGraph(1, 1, {
    [`${firstVariant?.data?.project?.name}`]: firstVariant?.parsedProject?.raw.map(
      (projectSheet) => projectSheet.Sheet
    ),
    [`${secondVariant?.data?.project?.name}`]: secondVariant?.parsedProject?.raw.map(
      (projectSheet) => projectSheet.Sheet
    ),
  });
  return (
    <>
      <div style={{ width: '100%' }}>
        <GraphicHeader />
      </div>

      <div style={{ width: '100%', height: '100%' }}>
        <HistogramVignetteComponent
          data={graphData}
          keys={graphKeys}
          total={impactTotal}
          acvComponent={true}
        />
      </div>
    </>
  );
}

export default AcvGraphic;
